import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { BrochureContext } from '../hooks/useBrochure';
import { BrochureLeadModal } from './BrochureLeadModal';

export function BrochureProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  // Nieuwe key per opening: het formulier start steeds leeg, ook als iemand
  // de brochure eerder in dezelfde sessie al heeft gedownload.
  const [session, setSession] = useState(0);

  const openBrochure = useCallback(() => {
    setSession((s) => s + 1);
    setOpen(true);
  }, []);
  const close = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({ openBrochure }), [openBrochure]);

  return (
    <BrochureContext.Provider value={value}>
      {children}
      <BrochureLeadModal key={session} open={open} onClose={close} />
    </BrochureContext.Provider>
  );
}
